import React from 'react';
import { Home, Video, User, Users, ShieldCheck } from 'lucide-react';
interface NavbarProps {
  currentPage: 'home' | 'resources' | 'recruiting';
  onNavigate: (page: 'home' | 'resources' | 'recruiting') => void;
  viewMode: 'admin' | 'employee';
  onViewModeChange: (mode: 'admin' | 'employee') => void;
}
export function Navbar({
  currentPage,
  onNavigate,
  viewMode,
  onViewModeChange
}: NavbarProps) {
  return <nav className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-525">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-526">
        <div className="flex justify-between h-16" data-id="element-527">
          <div className="flex" data-id="element-528">
            <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => viewMode === 'admin' && onNavigate('home')} data-id="element-529">
              <img src="https://cdn.magicpatterns.com/uploads/nShniaYpBxVejnwixTrGRA/UML_Logo.png" alt="United Mortgage Lending" className="h-8 w-auto" data-id="element-530" />
            </div>
            <div className="hidden sm:ml-8 sm:flex sm:space-x-8" data-id="element-531">
              {viewMode === 'admin' && <>
                  <button onClick={() => onNavigate('home')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'home' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-532">
                    <Home className="w-4 h-4 mr-2" data-id="element-533" />
                    Home
                  </button>
                  <button onClick={() => onNavigate('recruiting')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'recruiting' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-534">
                    <Users className="w-4 h-4 mr-2" data-id="element-535" />
                    Recruiting
                  </button>
                  <button onClick={() => onNavigate('resources')} className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors ${currentPage === 'resources' ? 'border-orange-500 text-gray-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'}`} data-id="element-536">
                    <Video className="w-4 h-4 mr-2" data-id="element-537" />
                    Company Resources
                  </button>
                </>}
              {viewMode === 'employee' && <span className="inline-flex items-center px-1 pt-1 border-b-2 border-transparent text-sm font-medium text-gray-500" data-id="element-538">
                  <span className="bg-orange-50 text-orange-700 px-2.5 py-0.5 rounded-full text-xs font-medium" data-id="element-539">
                    Employee View
                  </span>
                </span>}
            </div>
          </div>
          <div className="flex items-center gap-4" data-id="element-540">
            <div className="hidden md:flex items-center bg-gray-100 rounded-lg p-1" data-id="element-541">
              <button onClick={() => onViewModeChange('admin')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${viewMode === 'admin' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-542">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-543" />
                Admin
              </button>
              <button onClick={() => onViewModeChange('employee')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${viewMode === 'employee' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-544">
                <Users className="w-3.5 h-3.5" data-id="element-545" />
                Employee
              </button>
            </div>
            <div className="flex-shrink-0 border-l border-gray-200 pl-4 ml-2" data-id="element-546">
              <div className="flex items-center gap-3" data-id="element-547">
                <div className="text-right hidden md:block" data-id="element-548">
                  <p className="text-sm font-medium text-gray-900" data-id="element-549">
                    Sarah Johnson
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-550">
                    {viewMode === 'admin' ? 'HR Director' : 'Employee'}
                  </p>
                </div>
                <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 border border-orange-200" data-id="element-551">
                  <User className="h-5 w-5" data-id="element-552" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:hidden border-t border-gray-200" data-id="element-553">
        <div className="flex justify-around p-2" data-id="element-554">
          {viewMode === 'admin' ? <>
              <button onClick={() => onNavigate('home')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'home' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-555">
                <Home className="w-5 h-5" data-id="element-556" />
                <span className="text-xs mt-1" data-id="element-557">Home</span>
              </button>
              <button onClick={() => onNavigate('recruiting')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'recruiting' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-558">
                <Users className="w-5 h-5" data-id="element-559" />
                <span className="text-xs mt-1" data-id="element-560">Recruiting</span>
              </button>
              <button onClick={() => onNavigate('resources')} className={`flex flex-col items-center p-2 rounded-md ${currentPage === 'resources' ? 'text-orange-600 bg-orange-50' : 'text-gray-500'}`} data-id="element-561">
                <Video className="w-5 h-5" data-id="element-562" />
                <span className="text-xs mt-1" data-id="element-563">Resources</span>
              </button>
            </> : <div className="p-2 text-sm text-gray-500 font-medium" data-id="element-564">
              Employee Portal
            </div>}
        </div>
        <div className="p-3 border-t border-gray-100 bg-gray-50 flex justify-center" data-id="element-565">
          <div className="flex items-center bg-white rounded-lg p-1 border border-gray-200 shadow-sm" data-id="element-566">
            <button onClick={() => onViewModeChange('admin')} className={`flex items-center gap-1.5 px-4 py-2 rounded-md text-xs font-medium transition-all ${viewMode === 'admin' ? 'bg-gray-100 text-gray-900' : 'text-gray-500'}`} data-id="element-567">
              Admin
            </button>
            <button onClick={() => onViewModeChange('employee')} className={`flex items-center gap-1.5 px-4 py-2 rounded-md text-xs font-medium transition-all ${viewMode === 'employee' ? 'bg-gray-100 text-gray-900' : 'text-gray-500'}`} data-id="element-568">
              Employee
            </button>
          </div>
        </div>
      </div>
    </nav>;
}